var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import merge from 'lodash.merge';
import startCase from 'lodash.startcase';
import { mapValues } from '../../../utils/parsers';
import { applyFormat, formatAsDate, titleCase } from '../../../utils/strings';
export var parseEligibility = function (eligibility, parseOpts) {
    var defaultConfig = get(parseOpts, 'eligibility.default', {});
    var eligibilityConfig = get(parseOpts, "eligibility.".concat(eligibility), {});
    var _a = merge({}, defaultConfig, eligibilityConfig), color = _a.color, backgroundColor = _a.backgroundColor, borderLeftColor = _a.borderLeftColor;
    return {
        color: color,
        text: startCase(eligibility),
        css: {
            backgroundColor: backgroundColor,
            borderLeftColor: borderLeftColor,
        },
    };
};
export var parseTypicalAmountElement = function (typicalAmount, converter) {
    if (!converter[typicalAmount])
        return converter.fallback;
    var parsed = mapValues({
        values: { typicalAmount: typicalAmount },
        mapper: { typicalAmount: 'typicalAmount' },
        converter: converter,
    }).typicalAmount;
    return parsed;
};
export var parseList = function (list) {
    return list === null || list === void 0 ? void 0 : list.map(function (org) { return titleCase(org).replace(/_/g, ' '); }).join(', ');
};
export var parseTypicalAmount = function (typicalAmount, parseOpts) {
    return {
        label: parseTypicalAmountElement(typicalAmount, parseOpts.typicalAmount.label.converter),
        value: parseTypicalAmountElement(typicalAmount, parseOpts.typicalAmount.value.converter),
    };
};
export var parseEstimatedAmout = function (_a, parseOpts) {
    var eligibility = _a.eligibility, estimatedAmount = _a.estimatedAmount;
    var defaultConfig = get(parseOpts, 'estimatedAmount.css.default', {});
    var parsed = get(parseOpts, "estimatedAmount.css.".concat(eligibility), {});
    var css = merge({}, defaultConfig, parsed);
    return {
        value: applyFormat(__assign({ value: estimatedAmount }, parseOpts.estimatedAmount.format)),
        css: css,
    };
};
export function parse(_a, parseOpts) {
    var grantorName = _a.grantor_name, incentiveName = _a.incentive_name, incentiveDescription = _a.incentive_description, eligibility = _a.eligibility, eligibilityRationale = _a.eligibility_rationale, _b = _a.assumptions, assumptions = _b === void 0 ? [] : _b, eligibility_assumptions = _a.eligibility_assumptions, estimatedAmount = _a.estimated_amount, experiationDate = _a.expiration_date, typicalAmount = _a.typical_amount, _c = _a.eligible_organizations, eligibleOrganizations = _c === void 0 ? [] : _c, currentFunding = _a.current_funding, totalFunding = _a.total_funding, incetiveFocus = _a.incentive_focus, incentiveUrl = _a.incentive_url;
    return {
        grantorName: grantorName,
        incentiveName: incentiveName,
        incentiveDescription: incentiveDescription,
        status: parseEligibility(eligibility, parseOpts),
        eligibilityRationale: eligibilityRationale,
        assumptions: assumptions.concat(eligibility_assumptions),
        estimatedAmount: parseEstimatedAmout({ eligibility: eligibility, estimatedAmount: estimatedAmount }, parseOpts),
        expirationDate: formatAsDate(experiationDate, parseOpts.expirationDate),
        max: parseTypicalAmount(typicalAmount, parseOpts),
        organizations: parseList(eligibleOrganizations),
        totalAvailable: applyFormat(__assign({ value: currentFunding }, parseOpts.funding.format)),
        fundingToDate: applyFormat(__assign({ value: totalFunding }, parseOpts.funding.format)),
        applicabilaty: parseList(incetiveFocus),
        incentiveUrl: incentiveUrl,
    };
}
export function prepareMergedIncentives(evaluationsIncetives, commercialIncentives) {
    return evaluationsIncetives
        .map(function (_a) {
        var handle = _a.handle, _b = _a.assumptions, assumptions = _b === void 0 ? [] : _b, evalutationsIncetive = __rest(_a, ["handle", "assumptions"]);
        if (!commercialIncentives[handle]) {
            return null;
        }
        var _c = commercialIncentives[handle], eligibility_assumptions = _c.eligibility_assumptions, commercialIncentive = __rest(_c, ["eligibility_assumptions"]);
        return __assign(__assign(__assign({}, evalutationsIncetive), commercialIncentive), { assumptions: assumptions.concat(eligibility_assumptions) });
    })
        .filter(function (incentive) { return incentive; })
        .sort(function (i1, i2) {
        if (i1.estimated_amount < i2.estimated_amount)
            return 1;
        if (i1.estimated_amount > i2.estimated_amount)
            return -1;
        return 0;
    })
        .reduce(function (acc, incentive) {
        if (incentive.eligibility === 'eligible') {
            return __assign(__assign({}, acc), { eligible: acc.eligible.concat(incentive) });
        }
        if (incentive.eligibility === 'ineligible') {
            return __assign(__assign({}, acc), { ineligible: acc.ineligible.concat(incentive) });
        }
        return __assign(__assign({}, acc), { rest: acc.rest.concat(incentive) });
    }, {
        eligible: [],
        ineligible: [],
        rest: [],
    });
}
